import { Observable } from 'rxjs';

export type StockImageProviderName = 'pexels' | 'pixabay';
export type StockImageAspectRatio =
  | 'square'
  | 'landscape'
  /** The wide 3:1 banner an initiative or campaign cover photo is shown at. */
  | 'cover'
  | 'original';

export interface IStockImageCropSize {
  width: number;
  height: number;
}

export interface IStockImage {
  id: string;
  providerName: StockImageProviderName;
  /** Small, grid-sized URL. */
  thumbnailUrl: string;
  /** Larger URL used by the in-dialog preview. */
  previewUrl: string;
  /** URL we fetch bytes from when the user confirms the selection. */
  downloadUrl: string;
  width: number;
  height: number;
  description: string;
  photographerName: string;
  photographerUrl: string;
  /** Link back to the photo on the provider site, for credit. */
  providerUrl: string;
}

export interface IStockImageSearchResult {
  images: IStockImage[];
  page: number;
  perPage: number;
  totalResults: number;
  hasMore: boolean;
}

export interface IStockImageProvider {
  readonly name: StockImageProviderName;
  /** Human readable name, shown in the attribution line. */
  readonly displayName: string;
  /** False when the API key is missing from the environment config. */
  isConfigured(): boolean;
  search(
    query: string,
    page: number,
    perPage: number,
    aspectRatio?: StockImageAspectRatio,
  ): Observable<IStockImageSearchResult>;

  cropUrl?(image: IStockImage, size: IStockImageCropSize): string;

  readonly requiresAttribution?: boolean;

  readonly attributionUrl?: string;
}
